import {
  IconButton,
  Dialog,
  DialogTitle,
  AppBar,
  Toolbar,
  Typography,
  Box,
  CircularProgress,
  DialogContent,
  DialogActions,
  Tooltip,
  Button,
  TextField,
  Autocomplete,
  ListItem,
  ListItemAvatar,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { currencyFormat } from "../../common/components/Utils";

import { saveTrainer } from "../../../../store/cpd/actions";
import { getDistricts, getSectors } from "../../../../store/posts/actions";

import { isEmpty } from "lodash";
import axios from "axios";
import { CSVLink } from "react-csv";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import moment from "moment";
// import { showError } from "../../toastify";
import defaultPofile from "../../../assets/default-profile.jpg";
import { idNumberPattern } from "../../common/components/Utils";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import MaskedInput from "react-text-mask";
import joi from "joi";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const personalEmailValidator = joi.object({
  email: joi.string().email({
    minDomainSegments: 2,
    tlds: { allow: ["com", "fr", "rw"] },
  }),
});

const genders = [
  { id: "M", name: "Male" },
  { id: "F", name: "Female" },
];

const civilStatuses = [
  { id: "S", name: "Single" },
  { id: "M", name: "Married" },
  { id: "D", name: "Divorced" },
  { id: "W", name: "Widowed" },
  { id: "R", name: "Religious" },
];

const TrainerFormDialog = (props) => {
  const {
    user,
    loading,
    trainer,
    showDialog,
    setShowDialog,
    saveTrainer,
    trainerCategories,
    trainingProviders,
    getDistricts,
    totalRecods,
    setTotalRecods,
    countries,
  } = props;

  const onClose = () => {
    setShowDialog(false);
  };

  const [errors, setErrors] = useState({
    nidNumberHasError: false,
    emailHasError: false,
    phoneNumberHasError: false,
    providersHasError: false,
    trainerCategoryHasError: false,
    employeeIdHasError: false,
    staffCodeHasError: false,
    hasError: false,
  });

  const teacherInfoFormValidator = () => {
    const error = {
      nidNumberHasError: false,
      emailHasError: false,
      phoneNumberHasError: false,
      providersHasError: false,
      trainerCategoryHasError: false,
      employeeIdHasError: false,
      staffCodeHasError: false,
      hasError: false,
    };

    if (
      ((teacherForm.nidNumber || "").replace(/\s/g, "").length !== 16 ||
        !!idHasError) &&
      !!disabled()
    ) {
      error.nidNumberHasError = true;
      error.hasError = true;
    }

    if (!nationality) {
      error.nationalityHasError = true;
      error.hasError = true;
    }

    if (!disabled() && !teacherForm.passportNumber) {
      error.passportNumberHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.lastName) {
      error.lastNameHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.firstName) {
      error.firstNameHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.genderId) {
      error.genderIdHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.civilStatusId) {
      error.civilStatusIdHasError = true;
      error.hasError = true;
    }

    if (!teacherForm.dateOfBirth) {
      error.dateOfBirthHasError = true;
      error.hasError = true;
    }

    if ((teacherForm.phoneNumber || "").replace(/\s/g, "").length !== 10) {
      error.phoneNumberHasError = true;
      error.hasError = true;
    }

    if (
      !teacherForm.email ||
      (!!teacherForm.email &&
        personalEmailValidator.validate({ email: teacherForm.email }).error)
    ) {
      error.emailHasError = true;
      error.hasError = true;
    }

    if (!selectedCategories.length) {
      error.trainerCategoryHasError = true;
      error.hasError = true;
    }

    setErrors(error);

    if (error.hasError) {
      return true;
    }
    return false;
  };

  const [isVerifing, setIsVerifing] = useState(false);
  const [wasVerified, setWasVerified] = useState(false);
  const [idHasError, setIdHasError] = useState(false);

  const [selectedCategories, setSelectedCategories] = useState([]);
  // const [selectedProviders, setSelectedProviders] = useState([]);

  const [teacherForm, setTeacherForm] = useState({
    id: "",
    employeeId: "",
    nidNumber: "",
    nin: "",
    email: "",
    phoneNumber: "",
    gender: "",
    genderId: "",
    countryOfBirth: "",
    countryIdOfBirth: "",
    firstName: "",
    lastName: "",
    civilStatus: "",
    civilStatusId: "",
    spouseNames: "",
    fatherNames: "",
    motherNames: "",
    dateOfBirth: "",
    placeOfBirth: "",
    nationalityId: "",
    villageId: "",
    placementDate: null,
    profilePicture: "",

    rssbNumber: "",
    accountNumber: "",
    bankId: "",
    bankName: "",
    sdmsStaffCode: "",
  });

  useEffect(() => {
    getDistricts();
  }, []);

  const getNidDetails = async (nidNumber) => {
    try {
      let staff = {};
      try {
        const { data: tmisData } = await axios.get(
          "/api/users/search-staff/" + (nidNumber || "").replace(/\s/g, ""),
        );

        staff = tmisData;
      } catch (error) {}

      setWasVerified(false);
      setIsVerifing(true);

      const { data } = await axios.get(
        "/api/users/citizen/" + (nidNumber || "").replace(/\s/g, ""),
      );

      setTeacherForm({
        ...teacherForm,
        id: staff?.id || "",
        nidNumber: nidNumber,
        nin: data.nin,
        gender: data.gender,
        genderId: data.genderId,
        countryOfBirth: data.countryOfBirth,
        countryIdOfBirth: data.countryIdOfBirth,
        firstName: data.firstName,
        lastName: data.lastName,
        civilStatus: data.civilStatus,
        civilStatusId: data.civilStatusId,
        spouseNames: data.spouseNames,
        fatherNames: data.fatherNames,
        motherNames: data.motherNames,
        dateOfBirth: data.dateOfBirth,
        placeOfBirth: data.placeOfBirth,
        nationalityId: data.nationalityId,
        villageId: data.villageId,
        profilePicture: data.profileImage,

        employeeId: data.employee?.id || "",
        rssbNumber: data.employee?.rssbNumber || "",
        accountNumber: data.employee?.accountNumber || "",
        bankId: data.employee?.bankId || "",
        bankName: data.employee?.bankName || "",

        sdmsStaffCode: staff?.id || data.employee?.id || "",
        email: staff?.email?.trim() || "",
        phoneNumber: staff?.phoneNumber?.trim() || "",
      });

      // setChanged(true);
      setIdHasError(false);
      setWasVerified(true);
      setIsVerifing(false);
    } catch (error) {
      // setChanged(false);
      setIdHasError(true);
      setWasVerified(false);
      setIsVerifing(false);
    }
  };

  const onSave = () => {
    if (!teacherInfoFormValidator())
      saveTrainer(
        {
          id: teacherForm.id,
          employeeId: teacherForm.employeeId,
          lastName: teacherForm.lastName || null,
          firstName: teacherForm.firstName || null,
          email: teacherForm.email?.trim(),
          phoneNumber: teacherForm.phoneNumber?.trim(),
          nidNumber: teacherForm.nidNumber.replace(/\s/g, ""),
          passportNumber: teacherForm.passportNumber || null,
          nin: teacherForm.nin || null,
          gender: teacherForm.genderId || null,
          dateOfBirth: teacherForm.dateOfBirth || null,
          placeOfBirth: teacherForm.placeOfBirth || null,
          fatherNames: teacherForm.fatherNames || null,
          motherNames: teacherForm.motherNames || null,
          civilStatusId: teacherForm.civilStatusId || null,
          spouseNames: teacherForm.spouseNames || null,
          countryOfBirth: countryOfBirth?.id || null,
          nationalityId: nationality?.id || null,
          residenceVillageId: teacherForm.villageId || null,
          bankId: teacherForm.bankId || null,
          bankAccountNumber: teacherForm.accountNumber || null,
          rssbNumber: teacherForm.rssbNumber || null,
          categories: selectedCategories.map(({ id }) => id),
        },

        () => {
          if (!teacherForm.id) setTotalRecods(totalRecods + 1);
        },
        onClose,
      );
  };

  const [nationality, setNationality] = useState(null);
  const [countryOfBirth, setCountryOfBirth] = useState(null);

  useEffect(() => {
    if (!!countries.length) {
      setNationality(countries.find(({ id }) => id === "RW"));
      setCountryOfBirth(countries.find(({ id }) => id === "RW"));
    }
  }, [countries]);

  const disabled = () => nationality?.id === "RW";

  const [categories, setCategories] = useState([]);

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle className="text-primary pb-0 mb-0 text-uppercase border">
          <span className="d-flex align-items-center mb-2">
            <Typography className="d-flex align-items-center text-primary">
              <span className="text-dark mr-1">
                {!!trainer ? "Update " : "Add New "}
                {" Trainer"}
              </span>
              {!!trainer && (
                <>
                  {trainer?.lastName} {trainer?.firstName}
                </>
              )}
            </Typography>
          </span>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 4,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>

        <DialogContent className="px-0">
          <div className="mt-0" style={{ height: "100%" }}>
            <div
              style={{
                display: "table-cell",
                width: "100vw",
                height: "45vh",
                padding: "10px",
                verticalAlign: "middle",
              }}
            >
              <div className="row mx-0">
                <div className="col-4 text-left">
                  <Autocomplete
                    size="small"
                    defaultValue={null}
                    value={nationality}
                    options={countries}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => (
                      <Box component="li" {...props}>
                        {option.name}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={errors.nationalityHasError}
                        label="Nationality"
                        name="nationalityId"
                        placeholder="Nationality"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "countryId",
                        }}
                      />
                    )}
                    onChange={(event, selected) => {
                      setNationality(selected || null);
                      setCountryOfBirth(selected || null);

                      setErrors({
                        ...errors,
                        nationalityHasError: false,
                        countryOfBirthHasError: false,
                        hasError: false,
                      });
                    }}
                  />
                </div>

                {nationality?.id === "RW" && (
                  <div className="col-8 justify-content-center">
                    {!idHasError && !isVerifing && !wasVerified && (
                      <span className="material-icons loaderIcon text-danger">
                        help
                      </span>
                    )}

                    {!!isVerifing && (
                      <i
                        className="fas fa-spinner spinner loaderIcon text-primary"
                        style={{ fontSize: "22px" }}
                      ></i>
                    )}

                    {!isVerifing && !!idHasError && (
                      <span className="loaderIcon text-danger d-flex align-items-center">
                        <span className="material-icons text-danger">
                          report_problem
                        </span>
                        <span style={{ fontSize: "10px" }}>Error</span>
                      </span>
                    )}

                    {!idHasError && !isVerifing && !!wasVerified && (
                      <span className="loaderIcon text-success d-flex align-items-center">
                        <span className="material-icons text-success ">
                          verified
                        </span>
                        <span style={{ fontSize: "10px" }}>Verified</span>
                      </span>
                    )}

                    <MaskedInput
                      mask={idNumberPattern}
                      className="form-control "
                      placeholder="NID Number"
                      guide={false}
                      value={teacherForm.nidNumber}
                      onKeyPress={(e) => {
                        if (e.key === "Enter" && e.target.value.length === 21) {
                          getNidDetails(e.target.value);
                        }
                      }}
                      onChange={(e) => {
                        setTeacherForm({
                          ...teacherForm,
                          nidNumber: e.target.value,
                        });

                        if (e.target.value.length === 21) {
                          getNidDetails(e.target.value);
                        } else {
                          setIdHasError(false);
                          setWasVerified(false);
                          setIsVerifing(false);
                        }
                        setErrors({
                          ...errors,
                          nidNumberHasError: false,
                          emailHasError: false,
                          phoneNumberHasError: false,
                          employeeIdHasError: false,
                          staffCodeHasError: false,
                          hasError: false,
                        });
                      }}
                    />

                    {errors.nidNumberHasError && (
                      <small className="text-danger mb-1">
                        {!!teacherForm.nidNumber
                          ? "Invalid NID Number"
                          : " NID Number is required"}
                      </small>
                    )}
                  </div>
                )}

                {nationality?.id !== "RW" && (
                  <div className="col-8 text-left">
                    <TextField
                      fullWidth
                      size="small"
                      autoComplete="false"
                      name="passportNumber"
                      label="Passport number"
                      placeholder="Passport number"
                      variant="outlined"
                      value={teacherForm.passportNumber}
                      onChange={(e) => {
                        setTeacherForm({
                          ...teacherForm,
                          passportNumber: e.target.value,
                        });

                        setErrors({
                          ...errors,
                          passportNumberHasError: false,
                        });
                      }}
                    />
                    {errors.passportNumberHasError && (
                      <small className="text-danger mt-1">
                        Passport number is required
                      </small>
                    )}
                  </div>
                )}

                <div className="col-4 mt-3 text-left">
                  <TextField
                    error={errors.lastNameHasError}
                    style={disabled() ? { backgroundColor: "#f4f4f4" } : {}}
                    fullWidth
                    size="small"
                    name="lastName"
                    InputProps={{
                      readOnly: disabled(),
                    }}
                    label="Last Name"
                    placeholder="Last Name"
                    variant="outlined"
                    value={teacherForm.lastName}
                    onChange={(event) => {
                      setTeacherForm({
                        ...teacherForm,
                        lastName: event.target.value,
                      });

                      setErrors({
                        ...errors,
                        lastNameHasError: false,
                        hasError: false,
                      });
                    }}
                  />
                  {errors.lastNameHasError && (
                    <small className="text-danger mb-1">
                      Last name is required
                    </small>
                  )}
                </div>

                <div className="col-4 mt-3 text-left">
                  <TextField
                    error={errors.firstNameHasError}
                    style={disabled() ? { backgroundColor: "#f4f4f4" } : {}}
                    fullWidth
                    size="small"
                    name="firstName"
                    InputProps={{
                      readOnly: disabled(),
                    }}
                    label="First Name"
                    placeholder="First Name"
                    variant="outlined"
                    className=""
                    value={teacherForm.firstName}
                    onChange={(event) => {
                      setTeacherForm({
                        ...teacherForm,
                        firstName: event.target.value,
                      });

                      setErrors({
                        ...errors,
                        firstNameHasError: false,
                        hasError: false,
                      });
                    }}
                  />
                  {errors.firstNameHasError && (
                    <small className="text-danger mb-1">
                      First name is required
                    </small>
                  )}
                </div>

                <div className="col-4 mt-3 text-left">
                  <FormControl
                    style={disabled() ? { backgroundColor: "#f4f4f4" } : {}}
                    size="small"
                    required
                    fullWidth
                    error={errors.genderIdHasError}
                  >
                    <InputLabel id="genderId">Gender</InputLabel>
                    <Select
                      readOnly={disabled()}
                      labelId="genderId"
                      id="genderId"
                      value={teacherForm.genderId}
                      label="Gender"
                      placeholder="Gender"
                      onChange={(event) => {
                        setTeacherForm({
                          ...teacherForm,
                          genderId: event.target.value,
                        });

                        setErrors({
                          ...errors,
                          genderIdHasError: false,
                          hasError: false,
                        });
                      }}
                    >
                      {genders.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {errors.genderIdHasError && (
                    <small className="text-danger mb-1">
                      Gender is required
                    </small>
                  )}
                </div>

                <div className="col-4 mt-3 text-left">
                  <FormControl
                    style={disabled() ? { backgroundColor: "#f4f4f4" } : {}}
                    size="small"
                    required
                    fullWidth
                    error={errors.civilStatusIdHasError}
                  >
                    <InputLabel id="civilStatusId">Civil status</InputLabel>
                    <Select
                      readOnly={disabled()}
                      labelId="civilStatusId"
                      id="civilStatusId"
                      value={teacherForm.civilStatusId}
                      label="Civil status"
                      placeholder="Civil status"
                      onChange={(event) => {
                        setTeacherForm({
                          ...teacherForm,
                          civilStatusId: event.target.value,
                        });

                        setErrors({
                          ...errors,
                          civilStatusIdHasError: false,
                          hasError: false,
                        });
                      }}
                    >
                      {civilStatuses.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>

                <div className="col-4 mt-3 text-left">
                  {nationality?.id === "RW" ? (
                    <TextField
                      style={{ backgroundColor: "#f4f4f4" }}
                      fullWidth
                      size="small"
                      name="dateOfBirth"
                      value={
                        !!teacherForm.dateOfBirth
                          ? moment(teacherForm.dateOfBirth).format("DD/MM/yyyy")
                          : ""
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                      label="Date Of Birth"
                      placeholder="Date Of Birth"
                      variant="outlined"
                    />
                  ) : (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        maxDate={new Date()}
                        label="Date Of Birth"
                        placeholder="Date Of Birth"
                        inputFormat="dd/MM/yyyy"
                        value={teacherForm.dateOfBirth || null}
                        onChange={(date) => {
                          setTeacherForm({
                            ...teacherForm,
                            dateOfBirth: date || null,
                          });

                          setErrors({
                            ...errors,
                            dateOfBirthHasError: false,
                            hasError: false,
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            name="startDate"
                            onKeyDown={(e) => e.preventDefault()}
                            size="small"
                            fullWidth
                            {...params}
                            // error={!!cohort.errors?.startDate}
                            // helperText={cohort.errors?.startDate || ""}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                </div>

                <div className="col-4 mt-3 text-left">
                  {!disabled() ? (
                    <Autocomplete
                      size="small"
                      defaultValue={null}
                      value={countryOfBirth}
                      options={countries}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(option) => option.name}
                      renderOption={(props, option) => (
                        <Box component="li" {...props}>
                          {option.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={errors.countryOfBirthHasError}
                          label="Country Of Birth"
                          name="countryOfBirth"
                          placeholder="Country Of Birth"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "countryOfBirth",
                          }}
                        />
                      )}
                      onChange={(event, selected) => {
                        setCountryOfBirth(selected || null);

                        setErrors({
                          ...errors,
                          countryOfBirthHasError: false,
                          hasError: false,
                        });
                      }}
                    />
                  ) : (
                    <TextField
                      style={{ backgroundColor: "#e9ecef" }}
                      fullWidth
                      size="small"
                      name="countryOfBirth"
                      value={teacherForm.countryOfBirth}
                      InputProps={{
                        readOnly: true,
                      }}
                      label="Country of Birth"
                      variant="outlined"
                      className=""
                    />
                  )}
                </div>

                {/* <div className="col-4 mt-3 text-left">
                  <TextField
                    InputProps={{
                      readOnly: disabled(),
                    }}
                    style={disabled() ? { backgroundColor: "#f4f4f4" } : {}}
                    fullWidth
                    size="small"
                    name="placeOfBirth"
                    value={teacherForm.placeOfBirth}
                    label="Place of Birth"
                    placeholder="Place of Birth"
                    variant="outlined"
                    className=""
                    onChange={(e) => {
                      setTeacherForm({
                        ...teacherForm,
                        placeOfBirth: e.target.value || "",
                      });

                      setErrors({
                        ...errors,
                        placeOfBirthHasError: false,
                        hasError: false,
                      });
                    }}
                  />
                </div> */}

                {/* <div className="col-4  mt-3 text-left">
                  <TextField
                    style={{ backgroundColor: "#e9ecef" }}
                    fullWidth
                    size="small"
                    name="countryOfBirth"
                    value={teacherForm.countryOfBirth}
                    InputProps={{
                      readOnly: true,
                    }}
                    label="Country of Birth"
                    variant="outlined"
                    className=""
                  />
                </div> */}
                <div className="col-4 mt-3 text-left">
                  <TextField
                    style={{ backgroundColor: "#e9ecef" }}
                    fullWidth
                    size="small"
                    name="staffCode"
                    value={teacherForm?.id || ""}
                    label="Staff Code"
                    placeholder="Staff Code"
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                  />

                  {/* {errors.staffCodeHasError && (
                    <small className="text-danger mt-1">
                      Staff Code is required
                    </small>
                  )} */}
                </div>
                <div className="col-8 mt-3 text-left">
                  <TextField
                    style={{ backgroundColor: "#e9ecef" }}
                    fullWidth
                    size="small"
                    name="employeeId"
                    value={teacherForm?.employeeId || ""}
                    InputProps={{
                      readOnly: true,
                    }}
                    label="IPPIS Employee ID"
                    variant="outlined"
                    className=""
                  />

                  {errors.employeeIdHasError && (
                    <small className="text-danger mt-1">
                      Employee Id is required
                    </small>
                  )}
                </div>

                <div className="col-6  mt-3 text-left">
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="false"
                    name="phone"
                    label="Phone number"
                    placeholder="Phone number"
                    variant="outlined"
                    value={teacherForm.phoneNumber}
                    onChange={(e) => {
                      setTeacherForm({
                        ...teacherForm,
                        phoneNumber: e.target.value,
                      });

                      setErrors({
                        ...errors,
                        phoneNumberHasError: false,
                      });
                    }}
                  />
                  {errors.phoneNumberHasError && (
                    <small className="text-danger mt-1">
                      {!!teacherForm.phoneNumber
                        ? "Invalid Phone Number"
                        : " Phone Number is required"}
                    </small>
                  )}
                </div>
                <div className="col-6  mt-3 text-left">
                  <TextField
                    fullWidth
                    size="small"
                    autoComplete="false"
                    name="email"
                    label="Personal email"
                    placeholder="Personal email"
                    variant="outlined"
                    value={teacherForm.email}
                    onChange={(e) => {
                      setTeacherForm({
                        ...teacherForm,
                        email: e.target.value,
                      });
                      setErrors({
                        ...errors,
                        emailHasError: false,
                      });
                    }}
                  />

                  {errors.emailHasError && (
                    <small className="text-danger">
                      {!!teacherForm.email
                        ? "Invalid Personal email"
                        : " Personal email is required"}
                    </small>
                  )}
                </div>

                <div className="mt-3 col-12">
                  {/* <Autocomplete
                                        multiple
                                        className="mt-3"
                                        size="small"
                                        // disableCloseOnSelect
                                        defaultValue={[]}
                                        value={selectedTopics}
                                        options={topics}
                                        isOptionEqualToValue={(option, value) =>
                                          option.id === value.id
                                        }
                                        getOptionLabel={(option) => option.name}
                                        renderOption={(props, option, { selected }) => (
                                          <ListItem dense {...props}>
                                            <ListItemAvatar>
                                              <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                              />
                                            </ListItemAvatar>
                                            <ListItemText primary={option.name} />
                                          </ListItem>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            error={!!errors.topicsError}
                                            helperText={errors.topicsError || ""}
                                            name="topics"
                                            label="Select topics"
                                            placeholder="Select topics"
                                            inputProps={{
                                              ...params.inputProps,
                                            }}
                                          />
                                        )}
                                        onChange={(event, selected) => {
                                          setSelectedTopics(selected || []);
                  
                                          setErrors({ ...errors, topicsError: "" });
                                        }}
                                      /> */}

                  <Autocomplete
                    // size="small"
                    multiple
                    defaultValue={[]}
                    value={selectedCategories}
                    options={trainerCategories}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option, { selected }) => (
                      <ListItem dense {...props}>
                        <ListItemAvatar>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                        </ListItemAvatar>
                        <ListItemText primary={option.name} />
                      </ListItem>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Trainer category"
                        name="trainerCategory"
                        placeholder="Trainer category"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                    onChange={(event, selected) => {
                      setSelectedCategories(selected || []);

                      setErrors({
                        ...errors,
                        trainerCategoryHasError: false,
                      });
                    }}
                  />
                  {errors.trainerCategoryHasError && (
                    <small className="text-danger">
                      Trainer category is required
                    </small>
                  )}
                </div>

                {/* <div className="mt-3 col-12">
                            <Autocomplete
                              multiple
                              size="small"
                              defaultValue={[]}
                              value={selectedProviders}
                              options={trainingProviders}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              getOptionLabel={(option) => option.name}
                              renderOption={(props, option, { selected }) => (
                                <ListItem dense {...props}>
                                  <ListItemAvatar>
                                    <Checkbox
                                      icon={icon}
                                      checkedIcon={checkedIcon}
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                  </ListItemAvatar>
                                  <ListItemText primary={option.name} />
                                </ListItem>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Training provider"
                                  name="selectedProviders"
                                  placeholder="Training provider"
                                  inputProps={{
                                    ...params.inputProps,
                                  }}
                                />
                              )}
                              onChange={(event, selected) => {
                                setSelectedProviders(selected || []);

                                setErrors({
                                  ...errors,
                                  providersHasError: false,
                                });
                              }}
                            />
                            {errors.providersHasError && (
                              <small className="text-danger">
                                Training provider is required
                              </small>
                            )}
                          </div> */}
              </div>
              {/* </div> */}
              {/* </div> */}
              {/* </React.Fragment> */}
              {/* </div> */}
              {/* </div> */}
            </div>
          </div>
        </DialogContent>
        <DialogActions className=" d-flex justify-content-center py-4">
          <Button
            disabled={loading}
            color="primary"
            variant="contained"
            disableElevation
            size="sm"
            className="px-4"
            onClick={onSave}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({
  user,
  loading,
  onWait,
  placementReportDetails,
  changeList,
  prevPlacementReport,
  signatories,
  roles,
  districts,
  sectors,
  trainerCategories,
  trainingProviders,
  countries,
}) => {
  return {
    user,
    loading,
    onWait,
    placementReportDetails,
    changeList,
    prevPlacementReport,
    signatories,
    roles,
    districts,
    sectors,
    trainerCategories,
    trainingProviders,
    countries,
  };
};
export default connect(mapStateToProps, {
  saveTrainer,
  getSectors,
  getDistricts,
})(TrainerFormDialog);
